// Central site configuration — used by SEO, sitemap, structured data, etc.
export const SITE_URL = "https://www.magnolialunarspa.pt";
export const SITE_NAME = "Magnolia Lunar Spa";
// OG image: served locally by the backend from /api/files/... so social crawlers
// don't hit the removed Cloudflare R2 bucket. Must be an absolute URL for OG.
export const OG_IMAGE =
  `${SITE_URL}/api/files/magnolia-lunar/cdn/massages/massagem-tantrica/cover-1773411888989.jpg`;

export const LANG_MAP = {
  pt: "pt_PT",
  en: "en_US",
  es: "es_ES",
};

export const canonical = (path = "/") => {
  if (!path.startsWith("/")) path = `/${path}`;
  return `${SITE_URL}${path === "/" ? "" : path.replace(/\/$/, "")}` || SITE_URL;
};
